import { ExternalId } from './ExternalId'

import camelCaseKeys from 'camelcase-keys'

export class GuestCategory {
  constructor (params = {}) {
    const {
      id,
      sequence,
      externalIds,
      name,
      accessAreas,
      accessAreaIds,
      facility,
      facilityId
    } = camelCaseKeys(params, { deep: true })
    this.id = id || null
    this.sequence = sequence || null
    this.externalIds = externalIds ? externalIds.map((e) => new ExternalId(e)) : []
    this.name = name || null
    this.accessAreas = accessAreas || []
    this.accessAreaIds = accessAreaIds || []
    this.facilityId = facilityId || null
    this.facility = facility || this.facilityId
  }
  serialize (editedFields) {
    var item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
      id: item.id,
      name: item.name,
      facilityId: item.facilityId,
      accessAreaIds: item.accessAreaIds || []
    }
  }
}
